import React, { useState } from "react";
import useThemeColors from "../../vehicle/ThemeColors";
import { useRescheduleAppointmentMutation } from "../../../Services/inventory/Inventory";
import { toast } from "react-toastify";
import {
  WORKSHOP_ENDTIME,
  WORKSHOP_HOLIDAY,
  WORKSHOP_STARTTIME,
} from "../../../constants";
import dayjs, { Dayjs } from "dayjs";
import {
  DatePicker,
  TimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./rescheduleAppointment.scss";

interface IPROPS {
  closeModal: any;
  storeValue: any;
}

const RescheduleAppointment: React.FC<IPROPS> = ({
  closeModal,
  storeValue,
}) => {
  const [reason, setReason] = useState("");
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [selectedTime, setSelectedTime] = useState<Dayjs | null>(null);

  const getWorkshopHoliday = localStorage.getItem(WORKSHOP_HOLIDAY);
  const workshopStartTime = localStorage.getItem(WORKSHOP_STARTTIME);
  const workshopEndTime = localStorage.getItem(WORKSHOP_ENDTIME);

  const shouldDisableDate = (date: Dayjs) => {
    if (!getWorkshopHoliday) return false;
    const dayName = date.format("dddd");
    return getWorkshopHoliday.includes(dayName);
  };

  const [startHour, startMinute] = workshopStartTime?.split(":") || [];
  const [endHour, endMinute] = workshopEndTime?.split(":") || [];

  const now = dayjs();
  const nowPlus2Hours = now.add(2, "hour");

  const minWorkshopTime = dayjs()
    .set("hour", +startHour)
    .set("minute", +startMinute)
    .set("second", 0);

  const maxWorkshopTime = dayjs()
    .set("hour", +endHour)
    .set("minute", +endMinute)
    .set("second", 0);

  const selectedDateIsToday = selectedDate?.isSame(dayjs(), "day");

  const minTime = selectedDateIsToday
    ? dayjs.max(minWorkshopTime, nowPlus2Hours)
    : minWorkshopTime;

  const maxTime = maxWorkshopTime;

  const [rescheduleTrigger] = useRescheduleAppointmentMutation();

  const { selectedButtonBackgoundColors, selectedButtonColors } =
    useThemeColors();

  const updateHandler = async () => {
    if (!selectedDate || !selectedTime) {
      toast.error("Please select both date and time");
      return;
    }

    const appointmentDateTime = dayjs(selectedDate)
      .set("hour", selectedTime.hour())
      .set("minute", selectedTime.minute())
      .set("second", selectedTime.second())
      .format("YYYY-MM-DD HH:mm:ss");

    const reschedulePayload = {
      notes: reason,
      appointment_date: appointmentDateTime,
    };

    const response = await rescheduleTrigger({
      id: storeValue?.appointment_id,
      body: reschedulePayload,
    });

    if (response?.data) {
      toast.success(response.data.message);
      closeModal();
    } else if (response?.error && "data" in response.error) {
      const err = response.error as { data: { message: string } };
      toast.error(err.data.message);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <div style={{ marginTop: "20px" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div style={{ display: "flex", gap: "20px", width: "100%" }}>
              <DatePicker
                label="Select Date"
                value={selectedDate}
                onChange={(newDate) => setSelectedDate(newDate)}
                minDate={dayjs()}
                shouldDisableDate={shouldDisableDate}
              />
              <TimePicker
                label="Select Time"
                value={selectedTime}
                onChange={(newTime) => setSelectedTime(newTime)}
                ampm={false}
                minTime={minTime}
                maxTime={maxTime}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label style={{ fontFamily: "Karbon-regular", fontSize: "15px" }}>
                Reason
              </label>
              <textarea
                style={{ padding: "10px", borderRadius: "10px" }}
                placeholder="Enter Reason Here"
                onChange={(e) => setReason(e.target.value)}
                value={reason}
              />
            </div>
          </form>
        </LocalizationProvider>
      </div>

      <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
        <button
          className="btn btn-secondary"
          style={{ borderRadius: "13px", fontFamily: "Karbon-regular" }}
          onClick={() => closeModal()}
        >
          Cancel
        </button>
        <button
          onClick={updateHandler}
          style={{
            padding: "10px 25px",
            borderRadius: "20px",
            whiteSpace: "nowrap",
            background: selectedButtonBackgoundColors,
            color: selectedButtonColors,
            border: "none",
            fontSize: "13px",
            fontFamily: "Karbon-semi",
          }}
        >
          Reschedule Service
        </button>
      </div>
    </div>
  );
};

export default RescheduleAppointment;
